/// Appelé uniquement sur la page de coordonnees des listes mariages, pacs et cadeaux
/// /liste-cadeaux/creation-liste-[TypeList]
class Consultation extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize(idFormulaire) {
		let self = this;

		const form = new Formulaire(settings);
		form.initialize(idFormulaire);
		form.initialize('EnvoiRemerciements');
		form.initialize('EnvoiFairePart');

		document.querySelectorAll('.tagsfield').forEach(el => new Tagsfield(el));

		/// @mobile
		/// Gestion de l'affichage du libellé des onglets
		let selectorItemActif = document.querySelector('[data-item-actif]'),
			radios = document.querySelectorAll('[name="blockConsultation"]');

		for (let radio of radios) {
			document.addEventListener('DOMContentLoaded', function(){
				self.libelleActif(radios, selectorItemActif);
			})
			
			radio.addEventListener('change', function () {
				self.libelleActif(radios, selectorItemActif);
			});
		}

		/// Cocher/décocher tous les destinataires
		self.toggleAllCheckbox('CheckEmail');

		/// Prévisualisation
		/// Appel Ajax
		let forms = document.getElementById('container').querySelectorAll('.formulaire');

		for (var i = 0; i < forms.length; i++) {
			let id = forms[i].id,
				parent = forms[i].closest('.lmpc__tab').parentElement;
			self.submitForm(id, id, parent);
		}
	}

	saveEmail(id) {
		// Do something you need
		let field = document.querySelector('.tagsfield');
		const value = field.querySelector('span[contenteditable]').textContent.trim()
		const tagsValues = field.querySelector('input[type="hidden"]').value.split(';').filter(v => v.length > 0)

		if (value !== '') {
			field.querySelector('span[contenteditable]').value = tagsValues.join(';')
		}
		document.getElementById(id).requestSubmit();
	}

	toggleAllCheckbox(name) {
		let checkboxes = document.getElementsByName(name);

		document.querySelector('[data-button-allCheckbox]').addEventListener('click', function (el) {
			let isAllChecked = JSON.parse(el.target.dataset.buttonAllcheckbox),
				libelle = el.target.dataset.buttonLibelle;

			// On coche/décoche
			checkboxes.forEach(el => el.checked = !isAllChecked);
			// Update button
			el.target.dataset.buttonAllcheckbox = !isAllChecked;
			el.target.dataset.buttonLibelle = el.target.innerText;
			el.target.innerText = libelle;
		});

		let arr = [];
		checkboxes.forEach(el => {
			arr.push(el.checked);
		});

		let isAllCheck = arr.every(bool => bool);

		if (arr.length > 0 && isAllCheck) {
			document.querySelector(`[data-button-checkboxName="${name}"]`).innerText = 'Décocher tous les destinataires'
		}
	}

	submitForm(idFormulaire, url, container) {
		let self = this;

		document.getElementById(idFormulaire).addEventListener('submit', function (e) {
			e.preventDefault();

			if (!document.getElementById(idFormulaire).checkValidity()) {
				return true;
			}

			let data = new URLSearchParams(new FormData(e.target));
			let isPreview = e.submitter.dataset.quickview !== undefined;
			data.set('isPreview', isPreview);

			if (idFormulaire === 'EnvoiFairePart' && !isPreview) {
				let value = document.querySelector('.tagsfield span[contenteditable]').textContent.trim();

				if (value === '') {
					if (data.get('TextDestinataire') === '') {
						/// erreur
						return
					}
				} else {
					if (data.get('TextDestinataire') === '') {
						data.set('TextDestinataire', value);
					} else {
						let str = data.get('TextDestinataire');
						data.set('TextDestinataire', `${str};${value}`);
					}
				}
			}

			/// Recupération des éléments requis et non présent dans FormData (=> checkbox)
			let arrOfRequiredCheckbox = []
			for (let el of e.target) {
				if (el.dataset.elemRequired != undefined) {
					if (el.value === 'on') {
						arrOfRequiredCheckbox.push({
							'name': el.name,
							'value': el.checked
						})
					} else if (el.checked) {
						arrOfRequiredCheckbox.push({
							'name': el.name,
							'value': el.value
						})
					}

				}
			}

			if (arrOfRequiredCheckbox.length > 0) {
				let values = [];
				for (var i = 0; i < arrOfRequiredCheckbox.length; i++) {
					if (arrOfRequiredCheckbox[i].name === 'CheckEmail') {
						values.push(arrOfRequiredCheckbox[i].value.trim());
					} else {
						data.set(arrOfRequiredCheckbox[i].name, arrOfRequiredCheckbox[i].value);
					}
				}
				data.set('CheckEmail', values.join())
			}

			try {
				fetch(url, {
						method: 'POST',
						body: data
					})
					.then((resp) => {
						return resp.text();
					})
					.then((html) => {
						if (isPreview) {
							const winUrl = URL.createObjectURL(
								new Blob([html], {
									type: "text/html"
								})
							);

							const win = window.open(
								winUrl,
								"win",
								`location=no,directories=0,titlebar=0,menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=640,height=600`
							);
						} else {
							container.innerHTML = html;

							for (let field of data) {
								if (field[1] !== '' && document.getElementById(field[0]) !== null) {
									document.getElementById(field[0]).parentElement.classList.add('form-field--is-filled')
								}
							}
							self.submitForm(idFormulaire, url, container);
							document.querySelectorAll('.tagsfield').forEach(el => new Tagsfield(el));
						}
					});
			} catch (e) {
				console.error(e)
			}
		})
	}

	libelleActif(inputs, libelleMobile) {
		let self = this,
			valueChecked = "listeVersements";

		inputs.forEach(el => {
			if (el.checked) {
				valueChecked = el.id;
			}
		});

		/// Menu item actif
		document.querySelectorAll('[data-message-show] li').forEach(el => el.classList.remove('is-active'));
		document.querySelector(`[for="${valueChecked}"]`).parentElement.classList.add('is-active');

		/// Mobile
		helpers.isTouchDevice() && document.querySelector(`[for="${valueChecked}"]`).parentElement.scrollIntoView(true, {
			behavior: "smooth"
		});

	}
}